import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Resize from "src/components/common/resize";
import {
    weekDays, 
    getDateEndFromWeekNum, 
    getDatefromWeekNum, 
    getDateTime, 
    myAxios, MyFormData, 
    getTimeStamp, 
    simpleStatusColorCode, 
    isDevMode, 
    buildWeekNumArray, 
    weeknum, 
    MyDate, 
    standbyStartDate as startDate, 
    outsideEotDefaultEmptyData as defaultEmptyData,
    appTitle, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function EmergencyOT({ tabTitle }){
    const timeValid = (week) => getDateTime(week, 3, 11, 0) > new Date();
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = path.split("/")[1];
    const path2 = path.split("/")[2];
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [weeks] = useState(buildWeekNumArray(startDate).filter(week => (
        (getDateTime(week, 3, 0, 0) > (new Date(user.hireDate.replace(/-/g, "/")))) && 
        (user.quitDate?(getDateTime(week, 3, 0, 0) <= (new Date(user.quitDate.replace(/-/g, "/")))):true)
    )).reverse());
    const [week, setWeek] = useState(() => weeks.includes(path2)?path2:(
        weeks.includes(weeknum((new MyDate()).s()))?weeknum((new MyDate()).s()):
        (weeks.length?weeks[0]:"")
    ));
    //--------------------------------------------------------------------------------------------
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const setDivisions = useMyStore((state) => state.setOutsideserviceLocatorDivisions);
    const forms = useMyStore(state => state.outsideserviceIndividualEotForms);
    const setForms = useMyStore(state => state.setOutsideserviceIndividualEotForms);
    const form = forms[week] ?? {};
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt, 
        "Divisions": divisions.updatedAt === null?getTimeStamp():divisions.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [isEdittingContent, setIsEdittingContent] = useState(false);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            // ------------------------------
            setShowLoading(true);
            const resDivisions = await myAxios("outside/divisions/readDivisions.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resDivisions) return;
            // ------------------------------
            setDivisions(resDivisions.data, updateDateTime["Divisions"]);
        }
        if(updateDateTime["Divisions"] !== divisions.updatedAt) getData();
        return () => {isMounted = false;}
    },[updateDateTime["Divisions"]])
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("week", week);
            formData.append("action", "Read");
            //------------------------------
            setShowLoading(true);
            const res = await myAxios("outside/eot/eot.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //------------------------------
            setForms(week, JSON.parse(res.data[week] || defaultEmptyData), updateDateTime["Forms"]);
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {isMounted = false;}
    },[updateDateTime["Forms"], week])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Emergency OT
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span></span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">
                        Week:
                    </label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            setIsEdittingContent(false);
                            setWeek(e.currentTarget.value);
                            history.push(`/${path1}/${e.currentTarget.value}`);                   
                        }}
                    >
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?
                <div className = "cssLoading">Loading...</div>:
                JSON.stringify(form) === "{}"?<div className = "cssLoading">Empty</div>:
                <form
                    className = "p-3"
                    onSubmit = {async e => {
                        e.preventDefault();
                        if(!window.confirm("Are you sure to submit for the week?")) return;
                        const formData = new MyFormData();
                        formData.append("currentWeek", week);
                        formData.append("we", getDateEndFromWeekNum(week));
                        formData.append("data", JSON.stringify({...form, status: "Submitted"}));
                        formData.append("form", "office");
                        //------------------------------
                        setShowLoader(true);
                        const res = await myAxios("outside/eot/eot.php", formData);
                        setShowLoader(false);
                        if(!res) return;
                        //------------------------------
                        setUpdateDateTime({...updateDateTime, "Forms": getTimeStamp()});
                        history.replace(`/${path1}`);
                    }}
                >
                    <div className = "cssSeperateWhenWide align-items-center">
                        <div className = "h3 text-danger font-weight-bold mb-0">{getDateEndFromWeekNum(week)}</div>
                        <div className = "h4 mb-0 ml-2" style = {{color: simpleStatusColorCode[form.status]}}>{form.status}</div>
                        {!timeValid(week) && !form.unlock?<span className = "ml-2 text-light font-weight-bold bg-secondary rounded text-nowrap px-2 py-1">past</span>:<></>}
                        {form.form.every(day => day.availablity === "No")?<span className = "ml-2 text-light font-weight-bold bg-secondary rounded text-nowrap px-2 py-1">All No</span>:null}
                        {form.form.every(day => day.availablity === "Yes")?<span className = "ml-2 text-light font-weight-bold bg-secondary rounded text-nowrap px-2 py-1">All Yes</span>:null}
                    </div>
                    <div className = "row mt-2">
                        {[...weekDays.slice(4), ...weekDays.slice(0, 4)].map((weekday, i) => 
                        <div className = "col-lg" key = {i}>
                            <div className = "h4 text-secondary">{weekday} ({getDatefromWeekNum(week, i + 4)})</div>
                            <div className = "mt-2">
                                {isEdittingContent?
                                    <div>
                                        <label htmlFor = {`availablity ${i}`} className = "font-weight-bold">Availablity:</label>
                                        <select id = {`availablity ${i}`} required className = "form-control"
                                            value = {form.form[i].availablity}
                                            onChange = {e => {
                                                setForms(week, {
                                                    ...form, 
                                                    form: form.form.map(
                                                        (
                                                            (ff, weekday) => weekday === i?
                                                            ({
                                                                ...ff, 
                                                                availablity: e.currentTarget.value
                                                            }):ff
                                                        )
                                                    )
                                                });
                                            }}
                                        >
                                            <option value = "">Select</option>
                                            <option>Yes</option>
                                            <option>No</option>
                                        </select>
                                    </div>
                                    :
                                    <div>
                                        <label className = "font-weight-bold">Availablity:</label>
                                        <span className = "ml-2">{form.form[i].availablity}</span>
                                    </div>
                                }
                            </div>
                        </div>)}
                    </div>
                    <div className = "mt-2">
                        <label htmlFor = "yard" className = "font-weight-bold">Yard:</label>
                        {isEdittingContent?
                        <select id = "yard" className = "form-control w-auto"
                            required
                            value = {form.form[0].yard}
                            onChange = {e => {
                                setForms(week, {
                                    ...form, 
                                    form: form.form.map(
                                        (
                                            (ff, weekday) => weekday === 0?
                                            ({
                                                ...ff, 
                                                yard: e.currentTarget.value
                                            }):ff
                                        )
                                    )
                                });
                            }}
                        >
                            <option value = "">Select</option>
                            {divisions.data.map((d, key) => <option key = {key}>{d.division}</option>)}
                        </select>
                        :
                        <span className = "ml-2">
                            {form.form[0].yard}
                        </span>
                        }
                    </div>
                    {form.status === "Submitted" || (!timeValid(week) && !form.unlock)?<></>:
                    <div className = "text-right">
                        {isEdittingContent?
                        <>
                        <span className = "btn btn-info mx-3"
                            onClick = {() => {
                                setForms(week, {
                                    ...form, 
                                    form: form.form.map(
                                        (
                                            ff => 
                                            ({
                                                ...ff, 
                                                availablity: "No"
                                            })
                                        )
                                    )
                                });
                            }}
                        >
                            All No
                        </span>
                        <span className = "btn btn-info mx-3"
                            onClick = {() => {
                                setForms(week, {
                                    ...form, 
                                    form: form.form.map(
                                        (
                                            ff => 
                                            ({
                                                ...ff, 
                                                availablity: "Yes"
                                            })
                                        )
                                    )
                                });
                            }}
                        >
                            All Yes
                        </span>
                        <span className = "btn btn-info mx-3"
                            onClick = {async() => {
                                const formData = new MyFormData();
                                formData.append("currentWeek", week);
                                formData.append("data", JSON.stringify({...form, status: "Saved"}));
                                //------------------------------
                                setShowLoader(true);
                                const res = await myAxios("outside/eot/eot.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //------------------------------
                                setUpdateDateTime({...updateDateTime, "Forms": getTimeStamp()});
                                setIsEdittingContent(false);
                            }}>
                            Save Content
                        </span>
                        <button
                            type = "submit"
                            value = "Submit"
                            className = "btn btn-primary mx-3"
                        >
                            Submit For the Week
                        </button>
                        </>
                        :
                        <span className = "btn btn-info mx-3"
                            onClick = {async () => {
                                setUpdateDateTime({...updateDateTime, "Forms": getTimeStamp()});
                                setIsEdittingContent(true);
                            }}
                        >
                            Edit Content
                        </span>
                        }
                    </div>}
                </form>}
            </div>
        </div>
    )
}